import Module from "./apps/MicroModule.svelte";
import { mount } from "svelte";
window.MicroModule = function (options) {
    return mount(Module, options);
};
